/**
 * Notification popup custom JS
 * 
 * It has several options:
 * @param itemForLoggedIn Specify if the popup is visible only for logged-in users or for every user.
 * @param itemWhereToShow Specify if the popup is visible only on the home page or on every page of the website.
 * @param itemStartDate Specify the start date from which the popup should be shown to users.
 * @param itemEndDate Specify the end date until which the popup should be shown to users.
 * @param itemDisableDuration Specify what should happen when the user clicks itemConsentBtn - 'full' disables the popup permanently, 'session' shows   the popup again when the browser session expires.
 * 
 */

const popupContainer = document.querySelector('.notification-popup');

const popupItems = popupContainer?.querySelectorAll('.notification-popup__item');

document.addEventListener("DOMContentLoaded", () => {
  if (!popupItems) return;

  popupItems.forEach(item => {
    const itemID = item.id;
    const itemConsentBtn = item.querySelector('.consent-btn');
    const itemCloseBtn = item.querySelector('.close-btn');
    const itemStartDate = item.dataset.start;
    const itemEndDate = item.dataset.end;
    const itemDisableDuration = item.dataset.disableDuration;
    const itemWhereToShow = item.dataset.whereShow;
    const itemForLoggedin = item.hasAttribute('loggedin');
    const loggedinUser = (document.cookie.match(/^(?:.*;)?\s*LOGGEDIN\s*=\s*([^;]+)(?:.*)?$/) || ['null'])[1];

    let nowTimestamp = new Date().getTime();
    let startTimestamp = new Date(itemStartDate).getTime();
    let endTimestamp = new Date(itemEndDate).getTime();
    const day = 60 * 60 * 24 * 1000;

    if (endTimestamp + day < nowTimestamp) {
      localStorage.removeItem(itemID);
    }

    if (!(startTimestamp <= nowTimestamp && endTimestamp + day >= nowTimestamp)) return;

    if (!document.body.classList.contains('home') && itemWhereToShow === 'only_home') return;
    if (itemForLoggedin && !loggedinUser) return;
    
    if ((!localStorage.getItem(itemID) && itemDisableDuration == 'full') || (!sessionStorage.getItem(itemID) && itemDisableDuration == 'session')) {
      item.setAttribute('show', '');
      popupContainer.setAttribute('show', '');
      // document.body.style.overflow = "hidden";

      itemConsentBtn.addEventListener('click', () => {
        if (itemDisableDuration == 'full') {
          localStorage.setItem(itemID, '{"displayed": "true"}');
        } else if (itemDisableDuration == 'session') {
          sessionStorage.setItem(itemID, '{"displayed": "true"}');
        }

        closePopup(item);
      });
    }

    itemCloseBtn.addEventListener('click', () => {
      closePopup(item);
    });
  });

  const closePopup = (item) => {
    item.removeAttribute('show');

    if (!document.querySelectorAll('.notification-popup__item[show]').length > 0) {
      document.querySelector('.notification-popup').removeAttribute('show');
      // document.body.style.overflow = "";
    }
  }
});